import dayjs from 'dayjs';

import { toPlaceInputs } from 'utils/jobAdLocations';

export const jobAdToRepostValues = (jobAd, usesNuts) => ({
  buyer: jobAd.buyer_id,
  buyerName: jobAd.buyer_name || '',
  hideBuyer: true,
  sourceAdID: jobAd.ad_id,
  supplierID: null,
  headline: jobAd.headline || '',
  role: jobAd.role || '',
  experienceLevel: jobAd.experience_level || '',
  description: jobAd.description || '',
  type: jobAd.type || 'On site',
  hoursPerWeek: jobAd.hours_per_week || 40,
  maxRate: jobAd.max_rate || '',
  referenceNumber: jobAd.reference_number || '',
  startDate: jobAd.start_date ? dayjs(jobAd.start_date) : null,
  endDate: jobAd.end_date ? dayjs(jobAd.end_date) : null,
  applicationType: jobAd.application_method || 'in_app',
  applicationEmail: '',
  applicationURL: '',
  lastDayToRespond: jobAd.last_day_to_respond ? dayjs(jobAd.last_day_to_respond) : null,
  questionsEndDate: jobAd.questions_end_date ? dayjs(jobAd.questions_end_date) : null,
  locations: usesNuts ? (jobAd.locations ?? []).map((location) => location.Code) : [],
  places: toPlaceInputs(jobAd.places),
  usesNuts,
  additionalPeriods: (jobAd.additional_periods ?? []).map(({ period_id, parent_id, ...period }) => period),
  competenceAreas: jobAd.competence_areas ?? [],
});
